// Import Modernizr and the Bootstrap components that are needed
/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
/* eslint-disable import/no-extraneous-dependencies */
import Modernizr from 'modernizr';

// Bootstrap components
import Alert from 'Alert';
import Button from 'Button';
import Carousel from 'Carousel';
import Collapse from 'Collapse';
import Dropdown from 'Dropdown';
import Modal from 'Modal';
import Popover from 'Popover';
import Scrollspy from 'Scrollspy';
import Tab from 'Tab';
import Tooltip from 'Tooltip';
import Util from 'Util';
/* eslint-enable import/no-extraneous-dependencies */
/* eslint-enable import/no-unresolved */
/* eslint-enable no-unused-vars */

import $ from 'jquery';
import Inputmask from 'Inputmask';

// Custom Components
import './components/header';
import './components/gas-calculator';
import './components/calculator';
import './components/tabs-accord';
import './components/tabs-filter';
import './components/secondary-nav';
import './components/country-picker';
import './components/forms';
import './components/find-a-wubs';
import './components/find-an-office';
import './components/promo-card';
import './components/resources';
import './components/mass-pay-menu';
import './components/intelligence-form';
import './components/cookie-consent';
import './components/figure-modal';
import './components/payment-capabilities-map';
//import './components/edge-journey';
import './components/glossary';

$('[data-toggle="popover"]').popover();

$('[data-toggle="tooltip"]').tooltip();
